module.exports = __webpack_public_path__ + "media/images/icon-refresh-fb28444a399b497e0b0aa337535ef2e2.svg";